import { useParams, Link } from 'react-router-dom';
import { useT } from '../i18n/useT';
import { boardMemberProfile as bmpEn } from '../i18n/translations/en';
import { boardMemberProfile as bmpEs } from '../i18n/translations/es';
import { boardMembers, director } from '../data/boardMembers';
import './BoardMemberProfile.css';

const BoardMemberProfile = () => {
    const { id } = useParams();
    const t = useT({ en: bmpEn, es: bmpEs });
    const allMembers = [director, ...boardMembers];
    const member = allMembers.find(m => m.id === id);

    if (!member) {
        return (
            <div className="profile-not-found">
                <h2>{t.notFound}</h2>
                <Link to="/" className="btn btn-primary">{t.backHome}</Link>
            </div>
        );
    }

    return (
        <div className="profile-page">
            <div className="profile-back">
                <div className="container">
                    <Link to="/#board" className="profile-back-link">{t.backTeam}</Link>
                </div>
            </div>

            <section className="profile-hero">
                <div className="container profile-hero-inner">
                    <div className="profile-photo-wrap">
                        <img src={member.photo} alt={member.name} className="profile-photo" />
                    </div>
                    <div className="profile-identity">
                        {member.place && <span className="profile-place">{member.place}</span>}
                        <h1 className="profile-name">{member.name}</h1>
                        <span className="profile-role">{member.role}</span>
                        <p className="profile-org">Venus Community Service Development Corporation · Venus, Texas</p>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container profile-body">
                    <div className="profile-main">
                        <h2 className="profile-section-title">{t.about}</h2>
                        <p className="profile-bio">{member.bio}</p>

                        {member.achievements && member.achievements.length > 0 && (
                            <>
                                <h2 className="profile-section-title" style={{ marginTop: '2.5rem' }}>{t.achievements}</h2>
                                <ul className="profile-achievements">
                                    {member.achievements.map((a, i) => <li key={i}>{a}</li>)}
                                </ul>
                            </>
                        )}
                    </div>

                    <aside className="profile-sidebar">
                        <h3 className="profile-sidebar-title">{t.contact}</h3>

                        {member.phone && (
                            <div className="profile-contact-item">
                                <span className="profile-contact-label">{t.phone}</span>
                                <a href={`tel:${member.phone}`} className="profile-contact-value">{member.phone}</a>
                            </div>
                        )}

                        {member.email && (
                            <div className="profile-contact-item">
                                <span className="profile-contact-label">{t.email}</span>
                                <a href={`mailto:${member.email}`} className="profile-contact-value">{member.email}</a>
                            </div>
                        )}

                        <div className="profile-contact-item">
                            <span className="profile-contact-label">{t.org}</span>
                            <span className="profile-contact-value">Venus Community Service<br />Development Corporation</span>
                        </div>

                        <div className="profile-contact-item">
                            <span className="profile-contact-label">{t.address}</span>
                            <span className="profile-contact-value">700 W US Highway 67<br />Venus, Texas 76084</span>
                        </div>

                        <div className="profile-contact-form">
                            <h4>{t.sendMessage}</h4>
                            <form onSubmit={e => { e.preventDefault(); alert(t.messageSent); }}>
                                <input type="text" placeholder={t.formName} required />
                                <input type="email" placeholder={t.formEmail} required />
                                <textarea placeholder={t.formMessage} rows={4} required></textarea>
                                <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                                    {t.formSend}
                                </button>
                            </form>
                        </div>
                    </aside>
                </div>
            </section>
        </div>
    );
};

export default BoardMemberProfile;
